import { Page, QueryBase } from "../../shared/models/models";

export interface User {
  id: string;
  userName: string;
  email: string;
  isEmailConfirmed: boolean;
  isDisabled: boolean;
  createdDate: Date;
  modifiedDate: Date;
  loginDate: Date;
  role: UserRole;
  profile: UserProfile;
}

export interface ChangeUser {
  firstName: string;
  lastName: string;
  roleId: string;
}

export interface UserRole {
  id: string;
  name: string;
}

export interface UserProfile {
  firstName: string;
  lastName: string;
}

export interface AdminUsersState {
  query: UsersQuery;
  users?: Page<User>;
  user?: User;
  loading: boolean;
  success?: string;
  error: any;
}

export interface UsersQuery extends QueryBase<UsersQueryParameter> {
}

export enum UsersQueryParameter {
  email = 1,
  fullName = 2,
  role = 3,
  createdDate = 4,
  modifiedDate = 5,
  status = 6
}
